import React, { useState } from 'react'
import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'
import InView from 'react-intersection-observer'

const Branch: React.FC = () => {
	const { t } = useTranslation()
	const [startAnimation, setStartAnimation] = useState(false)

	return (
		<div className="row gx-0">
			<div className="col-md-6 position-relative">
				<Swiper
					modules={[Autoplay]}
					spaceBetween={0}
					slidesPerView={1}
					className={styles.swiper}
					autoplay
					loop
				>
					<SwiperSlide>
						<img src="/2021/images/branch/1.jpg?v=1" className={styles.img} />
					</SwiperSlide>
					<SwiperSlide>
						<img src="/2021/images/branch/2.jpg?v=1" className={styles.img} />
					</SwiperSlide>
					<SwiperSlide>
						<img src="/2021/images/branch/3.jpg?v=1" className={styles.img} />
					</SwiperSlide>
				</Swiper>
			</div>
			<div className="col-md-6 py-5 py-md-8">
				<div className={`container ${styles.textContainer}`}>
					<h2
						className={`display-1 text-uppercase text-primary font-weight-bold ${
							styles.headline
						} ${startAnimation ? styles.headlineAnimation : undefined}`}
					>
						{t('branch.title')}
					</h2>
					<InView onChange={(inView) => setStartAnimation(inView)}>
						<p className="line-height-lg">
							<Trans i18nKey="branch.text" components={[<strong />]} />
						</p>
					</InView>
				</div>
			</div>
		</div>
	)
}

export default Branch
